import { SCOPE_TYPE } from '../services/utils';

export interface PaymentsCSVDownloadParams {
  reportType: 'users' | 'chargers' | 'sessions';
  startDate: Date;
  endDate: Date;
  companyIds: string[];
  chargerIds?: string[];
  users?: string[];
  userScope?: SCOPE_TYPE;
}

export const MAX_CHARGER_SELECTION = 50;
export const SELECTION_VALUES = {
  ALL: 'all',
  ALL_CHARGERS: 'all_chargers',
  ALL_USERS: 'all_users',
  ALL_COMPANIES: 'all_companies',
} as const;

/**
 * Leaf node in the charger dropdown tree (an individual charger under a location).
 */
export interface ChargerDropdownChild {
  id: string;
  label: string;
  selected: boolean;
  indeterminate?: boolean;
}

/**
 * Top-level node in the charger dropdown tree. Either the synthetic "All chargers"
 * entry (id === SELECTION_VALUES.ALL, empty children) or a location grouping a
 * set of chargers.
 */
export interface ChargerDropdownItem {
  id: string;
  label: string;
  selected: boolean;
  indeterminate?: boolean;
  children: ChargerDropdownChild[];
}

export const getSelectedChargersCount = (chargerDropdownList: ChargerDropdownItem[]): number => {
  if (!chargerDropdownList || !Array.isArray(chargerDropdownList)) {
    return 0;
  }
  const locationGroups = chargerDropdownList.filter((i) => i.id !== SELECTION_VALUES.ALL);
  const allChargers = locationGroups.flatMap((loc) => loc.children || []);
  return allChargers.filter((ch) => ch.selected).length;
};

export const isAllChargersSelected = (chargerDropdownList: ChargerDropdownItem[]): boolean => {
  if (!chargerDropdownList || !Array.isArray(chargerDropdownList)) {
    return false;
  }
  const allChargersItem = chargerDropdownList.find((i) => i.id === SELECTION_VALUES.ALL);
  return allChargersItem?.selected || false;
};

export const getAllChargers = (items: ChargerDropdownItem[]): ChargerDropdownChild[] => {
  if (!Array.isArray(items)) return [];
  const locationGroups = items.filter((i) => i.id !== SELECTION_VALUES.ALL);
  return locationGroups.flatMap((loc) => loc.children || []);
};

export const downloadPaymentsCSV = (blobUrl: string, filename: string) => {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
